import { useState } from 'react'
import './Accordion.css'

/**
 * Accordion component for expandable content sections
 * Tracks engagement events on expand/collapse
 */
const Accordion = ({ 
  title, 
  icon, 
  children, 
  defaultExpanded = false,
  sectionId,
  onToggle 
}) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded)

  const handleToggle = () => {
    const newState = !isExpanded
    setIsExpanded(newState)
    
    // Track engagement event
    if (window.gtag) {
      window.gtag('event', 'accordion_toggle', {
        'section_id': sectionId,
        'section_title': title,
        'action': newState ? 'expand' : 'collapse',
        'event_category': 'engagement',
        'event_label': title
      })
    }
    
    // Also track with dataLayer for analytics
    if (window.dataLayer) {
      window.dataLayer.push({
        'event': 'accordion_toggle',
        'section_id': sectionId,
        'section_title': title,
        'action': newState ? 'expand' : 'collapse'
      })
    }
    
    // Call custom onToggle callback if provided
    if (onToggle) {
      onToggle(newState, sectionId, title)
    }
  }

  return (
    <div className={`accordion ${isExpanded ? 'accordion-expanded' : ''}`}>
      <button
        className="accordion-header"
        onClick={handleToggle}
        aria-expanded={isExpanded}
        aria-controls={`accordion-content-${sectionId}`}
        id={`accordion-header-${sectionId}`}
      >
        <div className="accordion-header-content">
          {icon && <span className="accordion-icon">{icon}</span>}
          <h3 className="accordion-title">{title}</h3>
        </div>
        <span className="accordion-chevron" aria-hidden="true">
          {isExpanded ? '▼' : '▶'}
        </span>
      </button>
      <div
        id={`accordion-content-${sectionId}`}
        className="accordion-content"
        aria-labelledby={`accordion-header-${sectionId}`}
        role="region"
        hidden={!isExpanded}
      >
        <div className="accordion-body">
          {children}
        </div>
      </div>
    </div>
  )
}

export default Accordion
